export default __webpack_public_path__ + "static/lframe-cards-2e4b0a54a3043836d7f82bf169eb5ce0.png";